import React from 'react';
import { IAttendeeUploadJobDetails, IAttendeeUploadJobResult } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';

const attendeesUploadJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IAttendeeUploadJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IAttendeeUploadJobDetails, IAttendeeUploadJobResult>) => {
        return <div className='alert-content'>
            <div className='alert-content__item'>Upload Complete</div>
            <div className='alert-content__item'>{props.result?.addedOrganizationsCount || 0} Organizations have been added</div>
            <div className='alert-content__item'>{props.result?.updatedOrganizationsCount || 0} Organizations have been updated</div>
            <div className='alert-content__item'>{props.result?.addedAttendeesCount || 0} Attendees have been added</div>
            <div className='alert-content__item'>{props.result?.updatedAttendeesCount || 0} Attendees have been updated</div>
        </div>;
    },
    failedComponent: (props: IJobResultComponentProps<IAttendeeUploadJobDetails, IAttendeeUploadJobResult>) => {
        return <AlertErrorMessage title='Upload Failed' message={props.result?.failureReason || 'Unknown failure reason'} />;
    },
};

export { attendeesUploadJobProperties };
